import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "upload-content-title" }
const _hoisted_2 = { class: "upload-pic-box" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex-fail-con" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "u-error-icon" }, null, -1)
const _hoisted_9 = { class: "u-error-content" }
const _hoisted_10 = {
  key: 1,
  class: "space"
}
const _hoisted_11 = { class: "submit-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionBar = _resolveComponent("ActionBar")!
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_upload_progress = _resolveComponent("upload-progress")!
  const _component_aio_confirm = _resolveComponent("aio-confirm")!

  return (_openBlock(), _createElementBlock("div", null, [
    true
      ? (_openBlock(), _createBlock(_component_ActionBar, {
          key: 0,
          actionBarInfo: $setup.actionBarInfo,
          needShare: false,
          theme: "black",
          onGoBack: _cache[0] || (_cache[0] = ($event: any) => ($setup.goback()))
        }, null, 8, ["actionBarInfo"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "upload-content",
      style: _normalizeStyle({ paddingTop: $setup.actionBarHeight + 'px' })
    }, [
      _createElementVNode("div", _hoisted_1, " 最多可上传" + _toDisplayString($setup.maxUpLoadNum[$setup.card_id + ""] || 6) + "张照片 ", 1),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.noteList || [], (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "pic",
            key: `img-${index}`,
            onClick: ($event: any) => ($setup.handlePreview(index))
          }, [
            _createElementVNode("img", {
              src: item.resource.indexOf('http') === 0 ? item.resource : item.base64,
              alt: ""
            }, null, 8, _hoisted_4),
            _createElementVNode("div", {
              class: "delete",
              onClick: _withModifiers(($event: any) => ($setup.deleteItem(index)), ["stop"])
            }, null, 8, _hoisted_5),
            (item.status && item.status !== '0')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "upload-fail-message",
                  onClick: _withModifiers(($event: any) => ($setup.uploadResources(index)), ["stop"])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.message || "图片上传失败"), 1)
                  ])
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        }), 128)),
        ($setup.noteList.length < $setup.maxUpLoadNum[$setup.card_id + ''])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "choose",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.callUploadAction && $setup.callUploadAction(...args)))
            }))
          : _createCommentVNode("", true),
        ($setup.noteList.length / 2 != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_van_sticky, {
        "offset-bottom": 58,
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.uploadResources && $setup.uploadResources(...args))),
              class: _normalizeClass(["submit-btn", { 'can-use': $setup.noteList.length }])
            }, " 提交笔记 ", 2)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_van_action_sheet, {
        show: $setup.callUploadActionVisible,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.callUploadActionVisible) = $event)),
        onSelect: $setup.handleSelectUploadAction,
        onCancel: $setup.handleUploadActionCancel,
        actions: $setup.callUploadActions,
        "cancel-text": "取消",
        "lock-scroll": "",
        "close-on-click-action": true,
        class: "upload-action-sheet"
      }, null, 8, ["show", "onSelect", "onCancel", "actions"]),
      _createVNode(_component_upload_progress, {
        uploadErrorFlag: $setup.uploadErrorFlag,
        total: $setup.totalUpload,
        doneNum: $setup.uploadedNum,
        failNum: $setup.uploadedFailNum,
        visible: $setup.uploadProgressVisible,
        onCancelUpload: $setup.cancelUpload
      }, null, 8, ["uploadErrorFlag", "total", "doneNum", "failNum", "visible", "onCancelUpload"]),
      _createVNode(_component_aio_confirm, {
        visible: $setup.confirmVisible,
        confirmInfo: $setup.confirmInfo
      }, null, 8, ["visible", "confirmInfo"]),
      _createVNode(_component_aio_confirm, {
        visible: $setup.confirmReUploadVisible,
        confirmInfo: $setup.confirmReUploadInfo
      }, null, 8, ["visible", "confirmInfo"])
    ], 4)
  ]))
}